/*! Wi-invoices - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

var url_invoice, url_save_invoice, url_delete_invoice, url_invoices;
+function ($) {
    'use strict';
    var wiInvoices = window.wiInvoices;

    window.wiInvoices = {
        init: function () {
            wiInvoices.events();
        },
        refresh: function () {
            wiPlugins.refresh();
        },
        events: function () {
            $(document).on('show.bs.tab', '.tab-invoices', function () {
                var ajaxloaded = $(this).attr('data-ajax-loaded');
                if (ajaxloaded === 'false') {
                    $(this).attr('data-ajax-loaded', true);
                    wiVars.set.variable('subreferral_id', 0);
                    wiVars.set.variable('subreferral_type', '');
                    wiVars.set.variables();
                    wiInvoices.get();
                }
            });
            $(document).on('click', '.add-invoice', function (event) {
                event.preventDefault();

                var click = $(this).attr('data-click');
                if (click) {
                    if ($(click).length) {
                        $(click).trigger('click');
                    }
                }

                wiVars.set.from.object($(this));

                wiModal.get({
                    modal: 'add_invoice',
                    module: 'invoices',
                    url: 'invoices',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    subreferral_id: subreferral_id,
                    subreferral_type: subreferral_type
                });
            });
            $(document).on('click', '.edit-invoice', function (event) {
                event.preventDefault();
                var invoice_id = $(this).attr('data-invoice-id');
                wiVars.set.from.object($(this));
                wiModal.get({
                    modal: 'edit_invoice',
                    module: 'invoices',
                    url: 'invoices',
                    language_id: language_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    subreferral_id: subreferral_id,
                    subreferral_type: subreferral_type,
                    invoice_id: invoice_id
                });
            });
            $(document).on('click', ".confirm-invoice-delete", function (event) {
                event.preventDefault();
                event.stopPropagation();
                var invoice_id = $(this).attr('data-invoice-id');
                wiVars.set.from.object($(this));
                wiModal.get({
                    modal: 'invoice_delete_confirmation',
                    module: 'invoices',
                    url: 'invoices',
                    language_id: language_id,
                    invoice_id: invoice_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    subreferral_id: subreferral_id,
                    subreferral_type: subreferral_type
                });
            });
            $(document).on('click', "#invoice_delete_btn", function (event) {
                event.preventDefault();
                event.stopPropagation();
                var form_data = $("#invoice_delete_form").serialize();
                $.ajax({
                    url: url_delete_invoice,
                    type: 'POST',
                    data: form_data,
                    success: function (jData) {
                        $('#invoice_delete_confirmation').modal('hide');
                        wiVars.set.from.response(jData);

                        wiAlerts.add(jData.status, jData.title, jData.msg);
                        wiInvoices.get();
                    }
                });
            });

            $(document).off('click', '#save_invoice_btn').on('click', '#save_invoice_btn', function (e) {
                e.preventDefault();

                const btn = this;
                const formWrapper = btn.closest('.modal-content') || document;
                const form = formWrapper.querySelector('#form_invoice');
                
                if (!(form instanceof HTMLFormElement)) {
                    console.error('The event target is not a form element.');
                    return;
                }

                const $form = $(form);
                
                const modal = btn.getAttribute('data-modal');
                const icon = btn.querySelector('.fa');
                const originalIconClass = 'fa-paper-plane';

                btn.disabled = true;
                icon?.classList.remove(originalIconClass);
                icon?.classList.add('fa-spinner', 'fa-spin');

                const formData = new FormData(form);
                formData.delete('userfile');
                formData.delete('userfiles[]');
                const files = window.fileStore?.get(form) || [];
                files.forEach(file => formData.append('userfiles[]', file));

                fetch(url_save_invoice, {
                    method: 'POST',
                    body: formData,
                })
                        .then(res => res.json())
                        .then(jData => {
                            btn.disabled = false;
                            icon?.classList.remove('fa-spinner', 'fa-spin');
                            icon?.classList.add(originalIconClass);

                            if (jData.status === 'success') {
                                window.fileStore.set($form[0], []);
                                wiVars.set.from.response(jData);
                                $('#invoice_id').val(jData.invoice_id);
                                wiInvoices.get();
                                $(modal).modal('hide');
                            }

                            if (typeof wiAlerts !== 'undefined') {
                                wiAlerts.add(jData.status, jData.title, jData.msg);
                            }
                        })
                        .catch(error => {
                            console.error('Invoice submit error:', error);
                            btn.disabled = false;
                            icon?.classList.remove('fa-spinner', 'fa-spin');
                            icon?.classList.add(originalIconClass);
                        });
            });
        },
        get: function () {
            $.get(
                    url_invoices,
                    {
                        language_id: language_id,
                        referral_id: referral_id,
                        referral_type: referral_type,
                        subreferral_id: subreferral_id,
                        subreferral_type: subreferral_type,
                        csrf_wicode: csrf_value
                    },
                    function (data) {

                        var invoice_area = $('#invoices_area');
                        invoice_area.html(data.invoices);
                    }
            );
        },
        post: function () {
            $.post(
                    url_invoices,
                    {
                        language_id: language_id,
                        referral_id: referral_id,
                        referral_type: referral_type,
                        subreferral_id: subreferral_id,
                        subreferral_type: subreferral_type,
                        csrf_wicode: csrf_value
                    },
                    function (data) {

                        var invoice_area = $('#invoices_area');
                        invoice_area.html(data.invoices);
                    }
            );
        }
    };
    $(function () {
        url_invoice = urls.invoices;
        url_save_invoice = urls.invoices + '/save_invoice';
        url_delete_invoice = urls.invoices + '/delete_invoice';
        url_invoices = urls.invoices + '/get_invoices';

        wiInvoices = window.wiInvoices;
        wiInvoices.init();
    });
}(jQuery);